<div class="kg-container px-4">
    <div *ngIf="!isAgentic" class="act-container py-2 d-flex justify-content-end">
        <button
        class="btn-accello-primary"
        type="button"
        (click)="generate()">
        <span class="v-center">
            <img src="assets/images/virtusa-icons/generate.svg" alt="reload" />
        </span>
        Generate Test Cases
        </button>
        <button [disabled]="filterData.userStory !== '' || filterData.weight != ''" class="btn-accello-secondary ms-2" (click)="downloadGraphAsHTML()">
            Download Graph
             @if(isDownloading){
                <span class="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
            }
        </button>
    </div>
    <div class="kg-body d-flex rounded">
        <div *ngIf="!isAgentic" class="filter-panel p-3 position-relative" [ngClass]="{ 'collapsed': !isExpanded }">
            <div>
                <label class="form-label"> Type </label>
                <div class="d-flex">
                    <div class="selector-card rounded flex-grow-1 p-2" [ngClass]="{ 'active': activeType === 'storyDriven', 'disabled': !clonedData?.storyDriven?.nodes?.length }" (click)="onTypeSelect('storyDriven')" (keydown)="onTypeSelect('storyDriven')">
                        <div class="text-end">
                            <input type="radio" value="storyDriven" name="storyDriven" [(ngModel)]="activeType">
                        </div>
                        <span>
                            Story-Driven Graph
                        </span>
                    </div>
                    <div class="selector-card rounded ml-10 flex-grow-1 p-2" [ngClass]="{ 'active': activeType === 'appContext', 'disabled': !clonedData?.appContext?.nodes?.length }" (click)="onTypeSelect('appContext')" (keydown)="onTypeSelect('appContext')">
                        <div class="text-end">
                            <input type="radio" value="appContext" [(ngModel)]="activeType" name="appContext">
                        </div>
                        <span>
                            Unified Graph
                        </span>
                    </div>
                </div>
            </div>
            <div class="fields-wrap" *ngIf="activeType === 'storyDriven'">
                <div class="mt-3">
                    <label class="form-label"> User Story ID </label>
                    <select [disabled]="displayProgress || isLoading" class="form-select" [(ngModel)]="filterData.userStory" (change)="onFilterChange('userStories')">
                        <option selected value=""> All </option>
                        <option *ngFor="let opt of filterOptions.userStories" [value]="opt.value"> {{ opt.label }} </option>
                    </select>
                </div>
                <div class="mt-3">
                    <label class="form-label"> Weight </label>
                    <select [disabled]="displayProgress || isLoading" class="form-select" [(ngModel)]="filterData.weight" (ngModelChange)="onFilterChange('weight')">
                        <option selected value=""> All </option>
                        <option *ngFor="let opt of filterOptions.weights" [value]="opt.value"> {{ opt.label }} </option>
                    </select>
                </div>
            </div>
            <div class="expander-btn v-center" (click)="expand()" (keydown)="expand()">
                <span class="expand-icon text-center">
                    <i class="bi bi-chevron-right"></i>
                </span>
            </div>
        </div>
        <div class="graph-wrap flex-grow-1">
            <div style="width: 100%; height: 100%;" *ngIf="isLoading">
                <app-loading></app-loading>
            </div>
            <div *ngIf="displayProgress" class="v-center h-100 w-75 mx-auto">
                <app-progress-bar [text]="progressText" [progress]="percentage" [isError]="isProgressError"></app-progress-bar>
            </div>
            <div style="width: 100%; height: 100%;" [hidden]="isLoading || displayProgress" #networkContainer></div>
        </div>
    </div>
</div>
